import { DownloadIcon } from "@chakra-ui/icons";
import { Box, Button, List, useDisclosure } from "@chakra-ui/react";

import { RanaModal } from "@nens/ranalib";

interface ModelCheckerErrorsProps {
  errors: string[];
  downloadTask?: () => void;
}

export function ModelCheckerErrors({ errors, downloadTask }: ModelCheckerErrorsProps) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  return (
    <Box>
      {errors && errors.length ? (
        <Box>
          <Button marginTop="4" variant="primary" onClick={onOpen}>
            View modelchecker errors
          </Button>
          <RanaModal isOpen={isOpen} onClose={onClose} topBar="Modelchecker errors">
            <p style={{ marginBottom: "4px" }}>There were {errors.length} errors:</p>
            <List styleType="none" spacing="4">
              {errors.map((error, i) => (
                <li key={error + i}>{error}</li>
              ))}
            </List>
            <Box my={4}>
              {downloadTask ? (
                <Button leftIcon={<DownloadIcon />} onClick={downloadTask} marginRight={4}>
                  View task JSON
                </Button>
              ) : null}
              <Button onClick={onClose}>Close</Button>
            </Box>
          </RanaModal>
        </Box>
      ) : null}
    </Box>
  );
}
